export default __webpack_public_path__ + "static/media/keystonejs.ce3e97ed.svg";